import { render } from "./EmailDashboard.vue?vue&type=template&id=12b8da53"
import script from "./EmailDashboard.vue?vue&type=script&lang=js"
export * from "./EmailDashboard.vue?vue&type=script&lang=js"

import "./EmailDashboard.vue?vue&type=style&index=0&id=12b8da53&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__